module.exports = __webpack_public_path__ + "img/7trebol.4808cc41.png";